import type { ReactNode } from "react";

// PRIMENG `p-inputGroup`: CHILDREN SIT FLUSH, AND ONLY THE GROUP'S OUTER CORNERS KEEP
// THEIR 4PX RADIUS. `className` CARRIES THE TEMPLATE'S OWN CLASSES (E.G. `w-6rem`).
export function InputGroup({ children, className = "" }: { children: ReactNode; className?: string }) {
  return (
    <div
      className={`p-inputgroup flex w-full ${className}`}
      style={{ alignItems: "stretch" }}
    >
      {children}
    </div>
  );
}
